// 指标，指标组类型
export const performanceGroupTypeList = [
  { label: '区体育行政部门', value: 'organ' },
  { label: '青训中心', value: 'youth' },
  { label: '精英机构/基地', value: 'club' },
  // { label: '训练营', value: 'trainCamp'},
]

// 计分方式

export const gradeType = [
  { label: '最高评分', value: 'TALLEST', },
  { label: '平均分', value: 'AVERAGE', },
]
export const auditStateListExtend = [
  { label: "待审核", value: "audit" },
  { label: "通过", value: "pass" },
  { label: "驳回", value: "refused" },
]
// 申报类型 - club用
export const stageTypeList = [
  // { label: "精英型", value: "精英型" },
  // { label: "提高型", value: "提高型" },
  // { label: "发展型", value: "发展型" },
  // { label: "一星级", value: "一星级" },
  // { label: "二星级", value: "二星级" },
  // { label: "三星级", value: "三星级" },
  // { label: "四星级", value: "四星级" },
  // { label: "五星级", value: "五星级" },
//  { label: "B类机构", value: "B类机构" },
  { label: "机构", value: "机构" },
]
// 申报类型 - 机构用
export const stageTypeList_base = [
  // 第一次考核显示内容
//  { label: "精英型", value: "精英型" },
//  { label: "提高型", value: "提高型" },
//  { label: "发展型", value: "发展型" },
  // 第二次考核显示内容
  { label: "上海市青少年足球精英培训机构", value: "上海市青少年足球精英培训机构" },
  { label: "上海市青少年足球培训机构", value: "上海市青少年足球培训机构" },
]

// 申报类型扩展
export const stageTypeListExtend = [
  { label: "机构（区级审核）", value: "机构" },
  { label: "机构（市级审核）", value: "机构" },
]
export const activityTypeEnumList = [
  {
    label: "向国家队输送球员，并参加世界杯、亚洲杯等国际足联、亚足联举办的正式比赛",
    value: "NATIONALTEAM",
  },
  {
    label: "向国奥、国青、国少队（15 岁及以上）输送球员，并参加正式比赛",
    value: "NATIONALYOUTHTEAM",
  },
  {
    label: "向本市全运队（资格赛、决赛）、三大球运动会（决赛）输送球员，并参加正式比赛",
    value: "GAMESTEAM",
  },
  {
    label: "向本市职业足球俱乐部一线队输送球员，并参加正式比赛",
    value: "CLUBTEAM",
  },
  {
    label: "向中国足协各级选拔集训队输送球员",
    value: "NATIONALTRAIN",
  },
  {
    label: "向本市全运队、三大球运动会选拔集训队（未进入资格赛、决赛名单）输送球员",
    value: "GAMESTRAIN",
  },
  {
    label: "向本市学青会、重点城市参赛队等输送球员并参加正式比赛",
    value: "POINTTEAM",
  },
  {
    label: "向本市职业足球俱乐部梯队输送球员",
    value: "CLUBTRAIN",
  },
  {
    label: "向本市/市足协各级青少年选拔集训队、训练营等输送球员",
    value: "DISTRICTTRAIN",
  },
  {
    label: "向区级代表队输送球员并参加市级及以上正式比赛。(仅限B类机构)",
    value: "DISTRICTTEAM",
  },
  {
    label: "向双一流、985及211高校输送球员",
    value: "TOPTRAIN",
  }
]
